export const sliceKey = 'instoreService';
